export const URL_PARAMS = { messageId: 'email_message_id' };
